import React from "react";
import ReplyReaction from "./ReplyReaction";
import { useMoodsContext } from "store/contexts/moodsContext";
import DeleteCommentModal from "components/DeleteCommentModal";
import { useUserContext } from "store/contexts/userContext";
import ReplyMessage from "./ReplyMessage";
import { useTimelineContext } from "store/contexts/timelineContext";

function ReplyFooter({ listTask, reply, teamRole, deleteMyExpression }) {
  const { moods } = useMoodsContext();
  const { user } = useUserContext();
  const { setHide } = useTimelineContext();

  return (
    <>
      <div className="comment-footer">
        <ReplyMessage listTask={listTask} reply={reply} />
        <div className="p-user-comment-footer post-footer">
          <div className="post-actions">
            <div className="left-actions">
              {(reply?.user?.id === user?.id || [2, 3].includes(teamRole)) && (
                <div className="p-delete-comment fs-12">
                  <DeleteCommentModal 
                    deleteMyExpression={deleteMyExpression} 
                    setHide={setHide}
                  />
                </div>
              )}
              {Boolean(moods) && Boolean(moods.length) && (
                <ReplyReaction listTask={listTask} reply={reply} />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ReplyFooter;
